export default __webpack_public_path__ + "static/media/featMb.cfdfa6ee.png";